import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';

import {NgxComponentKitModule} from '@ngx-component-kit/component-kit.module';
import {NgxTranslationsModule} from '@ngx-translations/translations.module';
import {NgxNotificationsModule} from '@ngx-notifications/notifications.module';
import {NgxAutosizeModule} from '@bravobit/ngx-autosize';
import {SlickCarouselModule} from 'ngx-slick-carousel';

import {HeadingComponent} from '@shared/components/heading/heading.component';
import {StateIndicatorComponent} from '@shared/components/state-indicator/state-indicator.component';
import {AlertComponent} from '@shared/components/alert/alert.component';
import {VideoThumbnailComponent} from '@shared/components/video-thumbnail/video-thumbnail.component';
import {FormatPipe} from '@shared/pipes/format.pipe';
import {ChangeProfileImageComponent} from '@shared/components/change-profile-image/change-profile-image.component';
import {ChangePasswordComponent} from '@shared/components/change-password/change-password.component';
import {PasswordRequestComponent} from '@shared/components/password-request/password-request.component';
import {PasswordResetComponent} from '@shared/components/password-reset/password-reset.component';
import {ToggleComponent} from '@shared/components/toggle/toggle.component';

const DECLARATIONS_EXPORTS = [
    HeadingComponent,
    StateIndicatorComponent,
    AlertComponent,
    VideoThumbnailComponent,
    ToggleComponent,
    FormatPipe,

    ChangeProfileImageComponent,
    ChangePasswordComponent,
    PasswordRequestComponent,
    PasswordResetComponent
];

const IMPORTS_EXPORTS = [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    // Custom library modules.
    NgxComponentKitModule,
    NgxTranslationsModule,
    NgxNotificationsModule,
    NgxAutosizeModule,
    SlickCarouselModule
];

@NgModule({
    imports: [...IMPORTS_EXPORTS],
    declarations: [...DECLARATIONS_EXPORTS],
    exports: [...DECLARATIONS_EXPORTS, ...IMPORTS_EXPORTS]
})
export class SharedModule {
}
